var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApproveCheckWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5889 7.15272C16.9543 8.94576 16.6939 10.8099 15.8512 12.4341C15.0085 14.0584 13.6344 15.3448 11.9581 16.0786C10.2818 16.8124 8.40462 16.9493 6.63956 16.4666C4.8745 15.9839 3.32828 14.9106 2.25875 13.4258C1.18921 11.9411 0.661024 10.1345 0.762258 8.30743C0.863491 6.48035 1.58803 4.74319 2.81504 3.38566C4.04206 2.02813 5.69739 1.13227 7.50497 0.847489C9.31256 0.562707 11.1631 0.906214 12.7481 1.82072",
    stroke: "white",
    strokeOpacity: 0.72,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35156 7.95253L8.75156 10.3525L16.7516 2.35254",
    stroke: "white",
    strokeOpacity: 0.72,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveCheckWhiteIcon);
export default __webpack_public_path__ + "static/media/approve-check-white-icon.4fa4da3915e3f3915618cdc6933edf2d.svg";
export { ForwardRef as ReactComponent };